import { APP_NAME } from "./constants";

/**
 * STOMP CONNECT headers (client-user-apps-recent-visits.md).
 * Server registers a 24h visit on CONNECT using AppName; closes duration on DISCONNECT.
 */
export function buildStompConnectHeaders(token) {
    if (!token) {
        throw new Error("STOMP CONNECT requires a JWT token");
    }
    return {
        Authorization: "Bearer " + token,
        AppName: APP_NAME,
    };
}
